import { render, staticRenderFns } from "./changePasswordPage.vue?vue&type=template&id=2b5d7158&"
import script from "./changePasswordPage.vue?vue&type=script&lang=js&"
export * from "./changePasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports